import CheckCicleOverlapIcon from 'icons/CheckCicleOverlap.icon';
import ClockIcon from 'icons/Clock.icon';
import DownloadIcon from 'icons/Download.icon';
import EyeIcon from 'icons/Eye.icon';
import LockclosedIcon from 'icons/Lockclosed.icon';
import WorkflowIcon from 'icons/Workflow.icon';
import { IconProp } from 'models/Icon';
import {
  DATA_ROOM_NODE_ACCESS_LEVELS,
  DATA_ROOM_NODE_ACCESS_STATES,
  DataRoomNodeAccessLevel,
  DataRoomNodeAccessState,
  DataRoomNodeWithStateAndSignal,
} from 'models/Lead';

export const MAX_NAME_LENGTH = 24;

export const ACCESS_STATE_ORDER: DataRoomNodeAccessState[] = [
  DATA_ROOM_NODE_ACCESS_STATES.VIEWED,
  DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED,
  DATA_ROOM_NODE_ACCESS_STATES.PENDING,
  DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS,
];

export const ACCESS_STATE_ICON: Record<DataRoomNodeAccessState, IconProp> = {
  [DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS]: LockclosedIcon,
  [DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED]: WorkflowIcon,
  [DATA_ROOM_NODE_ACCESS_STATES.PENDING]: ClockIcon,
  [DATA_ROOM_NODE_ACCESS_STATES.VIEWED]: CheckCicleOverlapIcon,
};

export const POPUP_HINT_COPY: Record<DataRoomNodeAccessState, string> = {
  [DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS]: 'clickToCycleAcces',
  [DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED]: 'clickToCycleAcces',
  [DATA_ROOM_NODE_ACCESS_STATES.PENDING]: 'filesWereShared5DaysAgo',
  [DATA_ROOM_NODE_ACCESS_STATES.VIEWED]: 'clickToCycleAcces',
};

export const createEmptyGroups = (): Record<
  DataRoomNodeAccessState,
  DataRoomNodeWithStateAndSignal[]
> => ({
  [DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS]: [],
  [DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED]: [],
  [DATA_ROOM_NODE_ACCESS_STATES.PENDING]: [],
  [DATA_ROOM_NODE_ACCESS_STATES.VIEWED]: [],
});

export const ACCESS_LEVEL_ICON: Record<DataRoomNodeAccessLevel, IconProp> = {
  [DATA_ROOM_NODE_ACCESS_LEVELS.NO_ACCESS]: LockclosedIcon,
  [DATA_ROOM_NODE_ACCESS_LEVELS.VIEW]: EyeIcon,
  [DATA_ROOM_NODE_ACCESS_LEVELS.DOWNLOAD]: DownloadIcon,
};

export const RELEASE_FILE_UNDO_COPY: Record<DataRoomNodeAccessLevel, string> = {
  [DATA_ROOM_NODE_ACCESS_LEVELS.NO_ACCESS]: 'releaseFileAccessRemoved',
  [DATA_ROOM_NODE_ACCESS_LEVELS.VIEW]: 'releaseFileAccessView',
  [DATA_ROOM_NODE_ACCESS_LEVELS.DOWNLOAD]: 'releaseFileAccessDownload',
};
